<template>
  <div class="analysis-tutorial-page col-block" :style="{ height: '100%', width: '100%', 'min-width': '1350px' }">
    <tutorialMain
      :type="tutorialType"
      :params="{
        renderItem: renderItem,
        display: display,
        toggle: toggle
      }"
    ></tutorialMain>
  </div>
</template>

<script>
import tutorialMain from '../../components/tutorial/main'

export default {
  components: {
    tutorialMain
  },
  computed: {
    analysisType () {
      return this.$route.name
    },
    tutorialType () {
      return {
        competitiveness: 'normal',
        attraction: 'normal',
        toolcompetitiveness: 'tool',
        toolattraction: 'tool'
      }[this.analysisType]
    },
    // static
    renderItem () {
      return {
        competitiveness: {
          '市場競爭力分析': true,
          '市場競爭力操作教學說明': true
        },
        attraction: {
          '市場吸引力分析': true,
          '市場吸引力操作教學說明': true
        },
        toolcompetitiveness: {
          '市場競爭力分析': true,
          '市場競爭力操作教學說明': true
        },
        toolattraction: {
          '市場吸引力分析': true,
          '市場吸引力操作教學說明': true
        }
      }[this.analysisType]
    },
    display () {
      return {
        competitiveness: {
          '市場競爭力分析': false,
          '市場競爭力操作教學說明': true
        },
        attraction: {
          '市場吸引力分析': false,
          '市場吸引力操作教學說明': true
        },
        toolcompetitiveness: {
          '市場競爭力分析': false,
          '市場競爭力操作教學說明': true
        },
        toolattraction: {
          '市場吸引力分析': false,
          '市場吸引力操作教學說明': true
        }
      }[this.analysisType]
    },
    toggle () {
      return {
        competitiveness: {},
        attraction: {},
        toolcompetitiveness: {},
        toolattraction: {}
      }[this.analysisType]
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/analysis/tutorial.vue